import React from 'react';
import './styles.scss';

export const Loader = () => {
	return <div className="loader" />;
};
export default Loader;
